module.exports = "https://99designs-start-assets.imgix.net/js/574ce38a817fb9906e9d8cb306dc269d.svg";